(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["es-product-reels"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('es-product-reels')) customElements.define('es-product-reels', class extends HTMLElement {
  connectedCallback() {
    this.videos = Array.from(this.querySelectorAll('video'));
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.manualPause = new WeakSet();
    this.userEnabled = new WeakSet();
    this.inView = new Set();
    this.labels = new WeakMap();
    this.play = (v) => {
      if (this.manualPause.has(v) || (this.reducedMotion && !this.userEnabled.has(v)) || document.hidden) return;
      v.defaultMuted = true;
      v.muted = true;
      v.playsInline = true;
      v.play().catch(() => {});
    };
    this.sync = (event) => {
      const v = event.target;
      v.setAttribute('aria-pressed', String(!v.paused));
      v.setAttribute('aria-label', `${this.labels.get(v)} — ${v.paused ? this.dataset.play : this.dataset.pause}`);
    };
    this.toggleVideo = (event) => {
      if (event.type === 'keydown' && event.key !== ' ' && event.key !== 'Enter') return;
      if (event.type === 'keydown') event.preventDefault();
      const v = event.currentTarget;
      if (v.paused) {
        this.manualPause.delete(v);
        this.userEnabled.add(v);
        this.play(v);
      } else {
        this.manualPause.add(v);
        v.pause();
      }
    };
    this.unlock = (event) => {
      if (this.contains(event.target) || this.reducedMotion) return;
      this.videos.forEach(this.play);
      window.removeEventListener('touchstart', this.unlock);
      window.removeEventListener('click', this.unlock);
    };
    this.ready = (event) => {
      if (this.inView.has(event.target)) this.play(event.target);
    };
    this.visibility = () => {
      if (document.hidden) this.videos.forEach(v => v.pause());
      else this.inView.forEach(this.play);
    };
    this.videos.forEach(v => {
      this.labels.set(v, v.getAttribute('aria-label'));
      v.controls = false;
      v.removeAttribute('controls');
      v.defaultMuted = true;
      v.muted = true;
      if (this.reducedMotion) { v.autoplay = false; v.pause(); }
      v.addEventListener('play', this.sync);
      v.addEventListener('pause', this.sync);
      v.addEventListener('click', this.toggleVideo);
      v.addEventListener('keydown', this.toggleVideo);
      v.addEventListener('canplay', this.ready);
      this.sync({target:v});
    });
    this.observer = new IntersectionObserver(entries => entries.forEach(({target, isIntersecting}) => {
      if (isIntersecting) { this.inView.add(target); this.play(target); }
      else { this.inView.delete(target); target.pause(); }
    }), {threshold: 0.25});
    this.videos.forEach(v => this.observer.observe(v));
    window.addEventListener('touchstart', this.unlock, {passive:true});
    window.addEventListener('click', this.unlock);
    document.addEventListener('visibilitychange', this.visibility);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    window.removeEventListener('touchstart', this.unlock);
    window.removeEventListener('click', this.unlock);
    document.removeEventListener('visibilitychange', this.visibility);
    this.videos?.forEach(v => {
      v.removeEventListener('play', this.sync);
      v.removeEventListener('pause', this.sync);
      v.removeEventListener('click', this.toggleVideo);
      v.removeEventListener('keydown', this.toggleVideo);
      v.removeEventListener('canplay', this.ready);
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
